
import logo from "../assests/logo.png"
export const SITE = {
  brand: "Lemonsqueezy Marketing Labs",
  tagline: "Zesty solutions. Seamless tech.",
  shortBrand: "Lemonsqueezy",
  logo:
    logo,
  phones: ["+91 70218 80154", "+91 70218 80155"],
  website: "lemonsqueezylabs.com",
  email:"contact@lemonsqueezylabs.com",
  whatsapp: "917021880155",
  socials: {
    linkedin: "https://www.linkedin.com/company/lemonsqueezy-marketing-labs",
    instagram:
      "https://www.instagram.com/lemonsqueezylabs?utm_source=qr&igsh=bWlmeWYyNnh5ODc4",
  },
};

export const NAV_LINKS = [
  { label: "Services", href: "#services" },
  { label: "Process", href: "#process" },
  { label: "Work", href: "#work" },
  { label: "Pricing", href: "#pricing" },
  { label: "Resources", href: "#resources" },
  { label: "Contact", href: "#contact" },
];
